import React from "react";

export const STATUS_LABEL = {
  scheduled: "Scheduled",
  picked_up: "Picked Up",
  in_transit: "In Transit",
  delivered: "Delivered",
  cancelled: "Cancelled",
};

const STYLES = {
  scheduled: "bg-gray-100 text-gray-800 border-gray-300",
  picked_up: "bg-blue-50 text-blue-800 border-blue-200",
  in_transit: "bg-amber-50 text-amber-800 border-amber-200",
  delivered: "bg-emerald-50 text-emerald-800 border-emerald-200",
  cancelled: "bg-red-50 text-red-800 border-red-200",
};

export default function StatusBadge({ status, className = "" }) {
  const style = STYLES[status] || STYLES.scheduled;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2 py-0.5 border ${style} text-[10px] uppercase tracking-[0.15em] font-bold ${className}`}
    >
      {STATUS_LABEL[status] || status}
    </span>
  );
}
